import BasePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import Form from '../form/form.vue';

export default {
  name: 'addForm',
  extends: BasePage,
  components: {
    Form,
  },
  props: {
    paramsProps: Object,
    formConfigData: Object,
  },
  data() {
    return {
      requestType: 'POST',
    };
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'delete') {
        if (this.selection.length > 0) {
          this.$confirm('是否确定要删除？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              const params = {
                ids: this.selection,
              };
              request.post('/mdm/mdmcustmainsubrelation/delete', params)
                .then((res) => {
                  if (res.success) {
                    this.$message({
                      type: 'success',
                      message: '操作成功',
                    });
                    this.getList();
                  }
                });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消',
              });
            });
        } else {
          this.$message('请至少选择一条数据！');
          return false;
        }
      } else if (val.code === 'add') {
        this.formName = 'Form';
        this.modalConfig.title = '新增';
        this.formConfig = {
          ...this.formConfigData,
          code: val.code,
          mainAndSub: 'sub',
        };
        this.openModal();
      }
      return true;
    },
    afterGetList() {
      this.exportParams = this.paramsProps;
      return true;
    },
    beforeGetList() {
      if (this.formConfigData.code === 'view') {
        this.configs.toolBarConfig = [];
      }
      return true;
    },
    // 获取列表数据
    getList() {
      if (this.beforeGetList()) {
        const { searchFormData, tablePage } = this;
        const params = {
          ...this.params,
          ...searchFormData,
          pageNum: tablePage.currentPage,
          pageSize: tablePage.pageSize,
        };
        Object.assign(params, this.paramsProps ? this.paramsProps : {});
        this.tableLoading = true;
        if (this.requestType === 'POST') {
          return request
            .post(
              this.requestUrl,
              { ...params },
              { headers: { functionCode: this.headerFunctionCode } },
            )
            .then((res) => {
              if (res.success) {
                this.tableLoading = false;
                if (res.result.data) {
                  this.tableData = res.result.data;
                  this.tablePage.totalResult = res.result.count;
                } else if (res.result.length >= 0) {
                  this.tableData = res.result;
                } else {
                  this.tableData = [];
                }
                this.afterGetList();
                this.setSelectData();
              }
            });
        }
      }
    },
  },
  created() {
    this.getConfigList('edit_list');
  },
};
